import React from 'react';

import Unfulfilled from '../../components/unfulfilled';

const Payment = () => {
    return <Unfulfilled />;
};

export default Payment;
